import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

/**
 * Generic 404 page shown when no route matches.
 */
const NotFoundPage = () => (
  <section className="not-found-page fade-in-up">
    <div className="container-small not-found-container">
      <h1>404</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Link to="/" className="btn-primary">Return Home</Link>
    </div>
  </section>
);

export default NotFoundPage;
